<script setup lang="ts">
const emits = defineEmits( ["goToBasket"] );
</script>

<template>
  <div>
    <h3>Product(s) added</h3>

    <p>Products have been added to your basket</p>

    <button
      class="btn btn-default btn-primary btn--md"
      type="button"
      @click="emits('goToBasket')">
      <span class="btn__label">
        Go to your basket
      </span>
    </button>
  </div>
</template>

<style scoped lang="scss">
.btn {
  padding: 0.375rem 0.75rem;
  cursor: pointer;
  margin-bottom: 5px;
}
</style>
